
export class FormMultipleProductsModel {
    fullName: string = '';
    documentId: string = '';
    phoneHome: string = '';
    phone: string = '';
    salary: string = '';
    email: string = '';
    selectionOpt: Array<string> = [];
    submitted: boolean = false;
  }